import React from 'react';
import styles from './styles.module.scss';

const iconPath =
    'm23.25 24c-.19 0-.38-.07-.53-.22l-10.72-10.72-10.72 10.72c-.29.29-.77.29-1.06 0s-.29-.77 0-1.06l10.72-10.72-10.72-10.72c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l10.72 10.72 10.72-10.72c.29-.29.77-.29 1.06 0s .29.77 0 1.06l-10.72 10.72 10.72 10.72c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22';

type CloseButtonProps = {
    onClick: () => void;
};

export const CloseButton = ({ onClick }: CloseButtonProps) => (
    <button onClick={onClick} className={styles.closeButton} type='button' aria-busy={false}>
        <svg
            viewBox='0 0 24 24'
            role='img'
            focusable='false'
            style={{
                display: 'block',
                fill: 'rgba(255,255,255,1)',
                height: '2em',
                width: '2em',
            }}
        >
            <path d={iconPath} fillRule='evenodd' />
        </svg>
    </button>
);
